export const uniqueSidebarNames = names => [
  ...new Set((Array.isArray(names) ? names : []).filter(Boolean)),
];

const orderByNames = (items, names) => {
  const positions = new Map(
    uniqueSidebarNames(names).map((name, index) => [name, index])
  );

  return [...items].sort((first, second) => {
    const firstPosition = positions.get(first.name);
    const secondPosition = positions.get(second.name);

    if (firstPosition === undefined && secondPosition === undefined) return 0;
    if (firstPosition === undefined) return 1;
    if (secondPosition === undefined) return -1;
    return firstPosition - secondPosition;
  });
};

export const orderSidebarSections = (
  sections,
  sectionNames = [],
  itemNames = []
) =>
  orderByNames(sections, sectionNames).map(section => ({
    ...section,
    items: orderByNames(section.items, itemNames),
  }));

export const resolveFavoriteMenuItems = (menuItems, favoriteNames) => {
  const itemsByName = new Map(
    menuItems
      .filter(item => item.type !== 'section' && item.show !== false)
      .map(item => [item.name, item])
  );

  return uniqueSidebarNames(favoriteNames)
    .map(name => itemsByName.get(name))
    .filter(Boolean);
};

export const excludeFavoriteMenuItems = (sections, favoriteItems) => {
  const favoriteNames = new Set(favoriteItems.map(item => item.name));

  return sections
    .map(section => ({
      ...section,
      items: section.items.filter(item => !favoriteNames.has(item.name)),
    }))
    .filter(section => section.items.length);
};
